export default function (theme) {
    return {
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    backgroundColor: theme.palette.background.surface,
                    margin: 0,
                    padding: 8
                }
            }
        }
    };
}